import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ICodeAndDescription, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class AlertCodeService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    Lookup(pCriteria: LookupCriteria): Promise<ICodeAndDescription[]>
    {
        return this.$apiService.sendAuth("IAlertService/LookupAlert", pCriteria);
    }
}
